import axios from "axios";
import { ISearchObj } from "../models/BaoCaoThongKeModels";
import QueryString from "qs";
import { localStorageItem } from "../../utils/LocalStorage";
import { KEY_LOCALSTORAGE } from "../../auth/core/_consts";

const API_PATH = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.["apiUrl"] || process.env.REACT_APP_API_URL;

export const paramsConfig = (searchObject: ISearchObj) => {
    let config = {
        params: searchObject,
        paramsSerializer: searchObject.listDepartmentId ? (searchObject: ISearchObj) => QueryString.stringify(searchObject) : undefined,
    };
    return config;
};

export const getTheoDoiTuongXayRaList = (searchObject: ISearchObj) => {
    const url = API_PATH + "/bao-cao/thong-ke-doi-tuong";
    return axios.get(url, paramsConfig(searchObject));
};

export const exportThongKeDoiTuong = (searchObject: ISearchObj) => {
    const url = API_PATH + "/bao-cao/export-thong-ke-doi-tuong";
    return axios({
        url: url,
        method: "GET",
        responseType: "blob",
        ...paramsConfig(searchObject),
    });
};
export const exportBaoCaoQuy = (searchObject: ISearchObj) => {
    const url = API_PATH + "/bao-cao/export-bao-cao-quy";
    return axios({
        url: url,
        method: "GET",
        responseType: "blob",
        ...paramsConfig(searchObject),
    });
};

export const getSoTheoDoiScykList = (searchObject: ISearchObj) => {
    const url = API_PATH + "/bao-cao/so-theo-doi-su-co";
    return axios.get(url, paramsConfig(searchObject));
};

export const exportSoTheoDoi = (searchObject: ISearchObj) => {
    const url = API_PATH + "/bao-cao/export-so-theo-doi-su-co";
    return axios({
        url: url,
        method: "GET",
        responseType: "blob",
        ...paramsConfig(searchObject),
    });
};

export const getThongKeTheoMucDoTT = (searchObject: ISearchObj) => {
    const url = API_PATH + "/bao-cao/muc-do-ton-thuong";
    return axios.get(url, paramsConfig(searchObject));
};

export const exportThongKeTheoMucDoTT = (searchObject: ISearchObj) => {
    const url = API_PATH + "/bao-cao/export-bao-cao-muc-do-ton-thuong";
    return axios({
        url: url,
        method: "GET",
        responseType: "blob",
        ...paramsConfig(searchObject),
    });
};

export const getThongKeTheoThang = (searchObject: ISearchObj) => {
    const url = API_PATH + "/bao-cao/thong-ke-thang";
    return axios.get(url, paramsConfig(searchObject));
};

export const exportThongKeTheoThang = (searchObject: ISearchObj) => {
    const url = API_PATH + "/bao-cao/export-thong-ke-thang";
    return axios({
        url: url,
        method: "GET",
        responseType: "blob",
        ...paramsConfig(searchObject),
    });
};
